module.exports = __webpack_public_path__ + "img/picture_s2examinationvideo1@2x.5f403426.png";